import { KeyboardEvent } from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
import Chip from '@mui/material/Chip';
import { InputType } from './../EditComponent';
import { chipStyles } from '../../../../utils/helpers';

interface OptionsType {
  id: string | number;
  [key: string]: string | number | boolean | undefined;
}

interface SelectEditComponentProps {
  label: string;
  localVal: InputType;
  handleSave: (
    value: InputType,
    e?: KeyboardEvent<HTMLDivElement> | KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>,
    displayValue?: string
  ) => void;
  handleClose: () => void;
  options?: string[] | OptionsType[];
}

const getChip = (label: string | null) => (
  <Chip
    label={label || '--None--'}
    size="small"
    sx={{ ...chipStyles(label || '--None--'), height: 'auto' }}
  />
);

export const SelectEditComponent = ({
  label,
  localVal,
  handleSave,
  handleClose,
  options
}: SelectEditComponentProps) => {
  const renderOption = (op: string | OptionsType) => {
    const isObject = typeof op === 'object' && op !== null;
    const value = isObject ? op.id : op;
    const text = isObject ? op.name || op.date || op.id : op;

    const content =
      isObject && ['Paid In', 'Corrects'].includes(label) ? (
        <span>
          {op.name} {getChip(op.status as string)}
        </span>
      ) : ['Commissions Status'].includes(label) ? (
        getChip(text ? String(text) : null)
      ) : (
        text || '--None--'
      );

    return (
      <MenuItem
        key={String(value)}
        value={value}>
        {content}
      </MenuItem>
    );
  };

  const getSelectedOption = (localVal: InputType) => {
    return (options as Array<string | OptionsType>)?.find((o) =>
      o && typeof o === 'object' ? o.id === localVal || o.name === localVal || o.date === localVal : o === localVal
    );
  };

  const selectedOption = getSelectedOption(localVal);

  const displayValue =
    selectedOption && typeof selectedOption === 'object' ? selectedOption.id : (selectedOption ?? '');

  const onSave = (value: InputType) => {
    const selectedOption = getSelectedOption(value);
    const displayValue =
      selectedOption && typeof selectedOption === 'object' ? (selectedOption.name as string) : undefined;
    handleSave(value, undefined, displayValue);
  };

  return (
    <FormControl
      sx={{ minHeight: '1rem', lineHeight: 1 }}
      fullWidth>
      <Select
        id="edit-component-select"
        size="small"
        data-testid="edit-component-select"
        value={displayValue}
        onChange={(e) => {
          let value: InputType = e.target.value;
          if (label.toLowerCase() === 'proactive') {
            value = value === 'Yes';
          }
          onSave(value);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleSave(undefined, e);
          }
          if (e.key === 'Escape') handleClose();
        }}
        onClose={handleClose}>
        {options?.map((op) => renderOption(op))}
      </Select>
    </FormControl>
  );
};
